import { RouteRecordRaw } from 'vue-router';
import { Layout } from '@/router/constant';
import { ShoppingOutlined, WalletOutlined, ItalicOutlined, FundOutlined} from '@vicons/antd';
import { renderIcon } from '@/utils/index';

/**
 * @param name 路由名称, 必须设置,且不能重名
 * @param meta 路由元信息（路由附带扩展信息）
 * @param redirect 重定向地址, 访问这个路由时,自定进行重定向
 * @param meta.disabled 禁用整个菜单
 * @param meta.title 菜单名称
 * @param meta.icon 菜单图标
 * @param meta.keepAlive 缓存该路由
 * @param meta.permissions 配置系统权限, 缺省开放所有权限
 * @param meta.sort 排序越小越排前
 * @param meta.hidden 从菜单中隐藏
 * @param meta.alwaysShow 总是显示菜单
 * @param meta.isRoot 单级菜单
 * */
const routes: Array<RouteRecordRaw> = [
  {
    path: '/purchasing',
    name: 'purchasing',
    redirect: '/purchasing/po',
    component: Layout,
    meta: {
      title: 'Purchasing',
      icon: renderIcon(ShoppingOutlined),
      permissions: ['purchasing_po_read', 'purchasing_invoice_read'],
      sort: 5,
    },
    children: [
      {
        path: 'po',
        name: 'purchasing_po',
        meta: {
          title: 'PO',
          icon: renderIcon(WalletOutlined),
          permissions: ['purchasing_po_read'],
        },
        component: () => import('@/views/purchasing/po/index.vue'),
      },
      {
        path: 'invoice',
        name: 'purchasing_invoice',
        meta: {
          title: 'Invoice',
          icon: renderIcon(ItalicOutlined),
          permissions: ['purchasing_invoice_read'],
        },
        component: () => import('@/views/purchasing/invoice/index.vue'),
      },
      {
        path: 'forecast',
        name: 'purchasing_forecast',
        meta: {
          title: 'Forecast',
          spname: 'purchasing_forecast_dashboard',
          icon: renderIcon(FundOutlined),
          permissions: ['purchasing_forecast_read'],
        },
        component: () => import('@/views/purchasing/forecast/index.vue'),
      },
    ],
  },
];

export default routes;
